import { useTranslation } from 'react-i18next';
import { Modal, ModalActionType, ModalVariant } from '@/components/Modal';
import { I18nNamespace } from '@/lib/i18n-namespaces';

const i18nNamespaces = [I18nNamespace.DIRECTORY, I18nNamespace.COMMON];

interface DeleteEntityConfirmationModalProps {
    isOpen: boolean;
    deleteInProgress?: boolean;
    count?: number;
    onConfirm: () => void;
    onCancel: () => void;
    titleKey: string;
    descriptionKey: string;
    submitKey: string;
    contentTestId?: string;
    submitButtonTestId?: string;
}

export function DeleteEntityConfirmationModal({
    isOpen,
    deleteInProgress,
    count = 1,
    onConfirm,
    onCancel,
    titleKey,
    descriptionKey,
    submitKey,
    contentTestId,
    submitButtonTestId,
}: DeleteEntityConfirmationModalProps) {
    const { t } = useTranslation(i18nNamespaces);

    return (
        <Modal
            isOpen={isOpen}
            title={t(titleKey, { count })}
            description={t(descriptionKey, { count })}
            onCancel={onCancel}
            onSubmit={onConfirm}
            submitInProgress={deleteInProgress}
            submitText={t(submitKey)}
            size="small"
            variant={ModalVariant.PLAIN}
            actionType={ModalActionType.DANGER}
            closeOnOutsideClick
            contentTestId={contentTestId}
            submitButtonTestId={submitButtonTestId}
        />
    );
}
